const FlywheelAlertCardAction = () => {
  // Return null to hide the "Add more" button for Alert cards
  return null;
};
export default FlywheelAlertCardAction;